<template>
  <div
    id="up-nav-bar-dropdown"
    class="flex px-6 py-8 items-start justify-between border-b border-slate-200 bg-white shadow-nav-menu z-30 absolute left-0 right-0"
  >
    <ul id="up-nav-bar-dropdown__list" class="flex flex-col gap-4 mr-12">
      <slot name="dropdownOptions" />
    </ul>
    <slot name="supportCard" />
  </div>
</template>
